import * as types from './boardList.types';
import * as constants from './boardList.constants';
import { generateResourceReducer } from '../../generators/resource.reducer';

export const boardListReducer = generateResourceReducer<types.IBoardList>({
  STORE: constants.STORE_BOARD_LIST,
  CLEAR: constants.CLEAR_BOARD_LIST,
});
